import React, { Fragment, useState, useEffect } from 'react';
import WebsiteVisitsChartCard from './WebsiteVisitsChartCard';
import Topic from './Topic';
import Contact from './Contact';
import Recommender from './Recommender';
import Country from './Country';
import ConservationsChartCard from './ConservationsChartCard';
import ChatTimeChartCard from './ChatTimeChartCard';
import Percentage from './Percentage';
import UserQuestions from './UserQuestions';
import 'moment-timezone';
import visitor from '../../../../../data/visitor';
import {
  Row,
  Col,
  Card,
  CardBody,
  UncontrolledDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Spinner,
  TabContent,
  TabPane,
  Tab,
  Nav,
  NavItem,
  NavLink,
  CardHeader,
} from 'reactstrap';
import Axios from 'axios';
import UserGuide from './UserGuide';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
  week,
  month,
  last7Days,
  last30Days,
  last90Days,
  year,
} from './lablesConfig';
import moment from 'moment';
import IntlMessages from '../../../../../helpers/IntlMessages';
import { faLock, faLockOpen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  gAPI_Voucher_Engine_Share_Stats,
  gAPI_VisitorsGroups_Stats,
  gAPI_VisitorsGroupsContact_Stats,
  gAPI_Voucher_Stats,
  gAPI_Ingetration,
  API_Ingetration,
  gAPI_Voucher_Ads_Stats,
  gAPI_Voucher_Engine_Stats,
  gAPI_Voucher_Engine_Sales,
  gAPI_Voucher_Country_Stats,
  gAPI_VisitorsGroupsMonth_Stats
} from '../../../../../constants/APIs';
import VoucherClicks from './VoucherClicks';
import VoucherEngineSales from './VoucherEngineSales';
import PopularVoucher from './PopularVoucher';
import RecentOrder from './RecentOrder';
import VoucherEngineVisits from './VoucherEngineVisits';
import topic from '../../../../../data/topic';
import ToDo from './ToDo';
import PopularAds from './PopularAds';
import VoucherEngineShare from './VoucherEngineShare';

const voucherEngineVisits = [
  {
    Header: 'Country',
    accessor: 'country',
    Cell: (props) => <p className="">{props.value}</p>,
  },
  {
    Header: 'Clicks',
    accessor: 'clicks',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
  {
    Header: 'Visitors',
    accessor: 'visitors',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
];
const poupularVoucherDataTablescolumn = [
  {
    Header: 'Name',
    accessor: 'voucherName',
    Cell: (props) => <p style={{ whiteSpace: 'normal' }}>{props.value}</p>,
  },
  {
    Header: 'Views',
    accessor: 'views',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
  {
    Header: 'Added to Cart',
    accessor: 'cart',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
  {
    Header: 'Payments',
    accessor: 'payments',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
  {
    Header: 'Purchases',
    accessor: 'purchases',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
  {
    Header: 'Clicks',
    accessor: 'clicks',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
  {
    Header: 'Share',
    accessor: 'share',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
];


const popularAdsDataTablecolumn = [
  {
    Header: 'Name',
    accessor: 'voucherName',
    Cell: (props) => <p style={{ whiteSpace: 'normal' }}>{props.value}</p>,
  },
  {
    Header: 'Impressions',
    accessor: 'impression',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
  {
    Header: 'Clicks',
    accessor: 'clicks',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
  {
    Header: 'Revenue',
    accessor: 'revenue',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  }
];

export default function ChartCard({
  propertyId,
  isVoucherEngine,
  timeZone,
  domains,
  currency, locale,
  history
}) {
  moment.tz.setDefault(timeZone);
  const [buttonText, setButtonText] = useState(
    <IntlMessages id="dashboards.last-7-days" />
  );
  const [activeTab, setActiveTab] = useState('ToDo');
  const [labels, setLabels] = useState(last7Days);
  const [visitorStatsData, setVisitorStatsData] = useState([]);
  const [contactStatsData, setContactStatsData] = useState([]);
  const [visitorQuestionsPageNumber, setvisitorQuestionsNumber] = useState(1);
  const [fromDate, setfromDate] = useState('');
  const [toDate, settoDate] = useState('');
  const [isWebsiteVisit, setIsWebsiteVisit] = useState(true);
  const [isContact, setContacts] = useState(true);
  const [clicks, setClicks] = useState([]);
  const [isclicks, setIsClicks] = useState(true);
  const [isPopularAds, setIsPopularAds] = useState(true);
  const [sales, setSales] = useState([]);
  const [isSales, setIsSales] = useState(true);
  const [shareStats, setShareStats] = useState([]);
  const [isShareStats, setIsShareStats] = useState(true);
  const [stats, setStats] = useState([]);
  const [isStats, setIsStats] = useState(true);
  const [statsData, setStatsData] = useState([]);
  const [popularAds, setPopularAds] = useState([]);
  const [integration, setIntregation] = useState([]);
  let [itegrationId, setIntregationId] = useState('All');
  const [integrationName, setIntregationName] = useState('All');
  const [countryvisit, setCountryVisit] = useState([]);
  const [isCountryStats, setIsCountryStats] = useState(true);
  // const [propertyLoaded, setpropertyLoaded] = useState(propertyId);
  const [isMasked, setIsMasked] = useState(sessionStorage.getItem('lock'));
  const maskEmail = (text) => {
    if (text !== null && text !== undefined) {
      let maskedvalue = text.replace(/()(.*)(?=@)/, function (gp1, gp2, gp3) {
        for (let i = 0; i < gp3.length; i++) {
          gp2 += 'X';
        }
        return gp2;
      });
      return maskedvalue;
    } else return '';
  };
  const maskMobile = (text, number) => {
    if (text !== null && text !== undefined) {
      let maskedValue = '';
      for (let i = 0; i < text.length - number; i++) {
        maskedValue += 'X';
      }
      return maskedValue + text.substring(text.length - number, text.length);
    } else return '';
  };
  const dataTableColumnsContacts = [
    {
      Header: 'Name',
      accessor: 'name',
      Cell: (props) => <p className="">{props.value}</p>,
    },
    {
      Header: 'Email',
      accessor: 'email',
      Cell: (props) => (
        <p className="">
          {isMasked !== 'true' ? maskEmail(props.value) : props.value}
          <span
            className="text-muted ml-1"
            style={{ cursor: 'pointer' }}
            onClick={handleMaskClick}
          >
            {props.value !== '' && (
              <FontAwesomeIcon
                icon={isMasked === 'true' ? faLock : faLockOpen}
                className="fa"
              />
            )}
          </span>
        </p>
      ),
    },
    {
      Header: 'Phone',
      accessor: 'phone',
      Cell: (props) => (
        <p className="">
          {isMasked !== 'true' ? maskMobile(props.value, 4) : props.value}
          <span
            className="text-muted ml-1"
            style={{ cursor: 'pointer' }}
            onClick={handleMaskClick}
          >
            {props.value !== '' && (
              <FontAwesomeIcon
                icon={isMasked === 'true' ? faLock : faLockOpen}
                className="fa"
              />
            )}
          </span>
        </p>
      ),
    },
    {
      Header: 'Zip Code',
      accessor: 'zipCode',
      Cell: (props) => <p className="">{props.value}</p>,
    },
    {
      Header: 'Marketing Consent',
      accessor: 'consent',
      Cell: (props) => <p className="">{props.value}</p>,
    },
    {
      Header: 'Date',
      accessor: 'consentDate',
      Cell: (props) => (
        <p className="">
          {props.value !== '' ? moment(props.value).format('lll') : ''}
        </p>
      ),
    },
  ];
  const handleMaskClick = () => {
    if (isMasked === 'true') {
      sessionStorage.setItem('lock', 'false');
      setIsMasked(sessionStorage.getItem('lock'));
    } else {
      sessionStorage.setItem('lock', 'true');
      setIsMasked(sessionStorage.getItem('lock'));
    }
  };
  useEffect(() => {
    if (propertyId !== '' && propertyId !== undefined) {
      selectLast7Days();
    }
    let body={
      channels:['EmbedVoucher','VoucherStandAlonePage','VoucherWebsite']
    };
    AxiosAPI({
      method: 'post',
      url: `${API_Ingetration}?group_id=${getGroupID()}`,
      data: body
    }).then((res) => {
      if (res.data.length > 0) {
        res.data = res.data.filter((m) => (m.channel === "EmbedVoucher" || m.channel === "VoucherStandAlonePage" || m.channel === "VoucherWebsite") && m.disabled === false && m.properties.filter(f => f === propertyId).length > 0)
      }
      setIntregation(res.data);
    });
  }, [propertyId]);
  const today = () => {
    return moment(moment().format('YYYY-MM-DD') + ' 23:59:59')
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const daysAgo7 = () => {
    return moment(moment().subtract(6, 'days').format('YYYY-MM-DD HH:mm:ss'))
      .utc()
      .format('YYYY-MM-DD 00:00:00');
  };

  const daysAgo30 = () => {
    return moment(moment().subtract(29, 'days').format('YYYY-MM-DD HH:mm:ss'))
      .utc()
      .format('YYYY-MM-DD 00:00:00');
  };

  const daysAgo60 = () => {
    return moment(moment().subtract(59, 'days').format('YYYY-MM-DD HH:mm:ss'))
      .utc()
      .format('YYYY-MM-DD 00:00:00');
  };

  const daysAgo90 = () => {
    return moment(moment().subtract(89, 'days').format('YYYY-MM-DD HH:mm:ss'))
      .utc()
      .format('YYYY-MM-DD 00:00:00');
  };

  const startOfWeek = () => {
    const today = moment();
    return moment(moment(today).isoWeekday(1).format('YYYY-MM-DD HH:mm:ss'))
      .utc()
      .format('YYYY-MM-DD 00:00:00');
  };

  const endOfWeek = () => {
    const today = moment();
    return moment(
      moment(today).isoWeekday(7).format('YYYY-MM-DD') + ' 23:59:59'
    )
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const startOfMonth = () => {
    return moment(moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'))
      .utc()
      .format('YYYY-MM-DD 00:00:00');
  };

  const startOfPreviousMonth = () => {
    return moment(
      moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD') +
      ' 00:00:00'
    )
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const startOfThisYear = () => {
    return moment(new Date().getFullYear() + '-01-01' + ' 00:00:00').format(
      'YYYY-MM-DD HH:mm:ss'
    );
  };



  const toggleAppMenu = (tab) => {
    setActiveTab(tab);
  };

  const startOfLastYear = () => {
    return moment(new Date().getFullYear() - 1 + '-01-01' + ' 00:00:00').format(
      'YYYY-MM-DD HH:mm:ss'
    );
  };
  const endOfLastYear = () => {
    return moment(new Date().getFullYear() - 1 + '-12-31' + ' 00:00:00').format(
      'YYYY-MM-DD HH:mm:ss'
    );
  };

  const endOfPreviousMonth = () => {
    return moment(
      moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD') +
      ' 23:59:59'
    )
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const endOfMonth = () => {
    return moment(moment().endOf('month').format('YYYY-MM-DD') + ' 23:59:59')
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const selectLast7Days = (id) => {
    setButtonText(<IntlMessages id="dashboards.last-7-days" />);
    setLabels(last7Days);

    setfromDate(daysAgo7());
    settoDate(today());

    setIsWebsiteVisit(false);

    setIsSales(true);
    setIsClicks(true);
    setIsStats(true);
    setIsCountryStats(true);
    if(propertyId !== undefined){
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroups_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo7(),
          dateTo: today(),
          propertyId: propertyId,
          iid: id,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo7(),
          dateTo: today(),
          propertyId: propertyId,
          iid: id,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Country_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo7(),
          dateTo: today(),
          propertyId: propertyId,
          iid: id,
        },
      }).then((res) => {
        setCountryVisit(res.data);
        setIsCountryStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Share_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          iid: id,
          fromDate: daysAgo7(),
          toDate: today(),
          type: 'Day',
        },
      }).then((res) => {
        setShareStats(res.data);
        setIsShareStats(false);
      }),

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Sales}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          iid: id,
          fromDate: daysAgo7(),
          toDate: today(),
          type: 'Day',
        },
      }).then((res) => {
        setSales(res.data);
        setIsSales(false);
      }),

      
      AxiosAPI({
        method: 'get',
        url: `${stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          iid: id,
          fromDate: daysAgo7(),
          toDate: today(),
          type: 'Day',
        },
      }).then((res) => {
        setSales(res.data);
        setIsSales(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: daysAgo7(),
          toDate: today(),
          type: 'Day',
          iid: id,
        },
      }).then((res) => {
        setClicks(res.data);
        setIsClicks(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: daysAgo7(),
          toDate: today(),
          type: 'Day',
          iid: id,
        },
      }).then((res) => {
        setStats(res.data);
        setIsStats(false);
        let v = 0,
          s = 0;
        if (res.data.voucher !== undefined && res.data.voucher.length > 0) {
          res.data.voucher.map((m) => {
            v = v + parseInt(m.views);
            s = s + parseInt(m.purchases);
          });
        }
        setStatsData({ views: v, sold: s });
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Ads_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: daysAgo7(),
          toDate: today(),
          type: 'Day',
          iid: id,
        },
      }).then((res) => {
        if (res.data.ads != undefined && res.data.ads.length > 0) {
          setPopularAds(res.data.ads);
          setIsPopularAds(false);
        }
      }),

    ]);
  }
  };

  const selectLast30Days = (id) => {
    setButtonText(<IntlMessages id="dashboards.last-30-days" />);
    setLabels(last30Days);

    setfromDate(daysAgo30());
    settoDate(today());

    setIsWebsiteVisit(false);

    setIsSales(true);
    setIsClicks(true);
    setIsStats(true);
    setIsCountryStats(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroups_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo30(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo30(),
          dateTo: today(),
          iid: id,
          propertyId: propertyId,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Country_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo30(),
          dateTo: today(),
          propertyId: propertyId,
          iid: id,
        },
      }).then((res) => {
        setCountryVisit(res.data);
        setIsCountryStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: daysAgo30(),
          toDate: today(),
          type: 'Day',
          iid: id,
        },
      }).then((res) => {
        setStats(res.data);
        setIsStats(false);
        let v = 0,
          s = 0;
        res.data.voucher.map((m) => {
          v = v + parseInt(m.views);
          s = s + parseInt(m.purchases);
        });
        setStatsData({ views: v, sold: s });
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Ads_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: daysAgo30(),
          toDate: today(),
          type: 'Day',
          iid: id,
        },
      }).then((res) => {
        if (res.data.ads != undefined && res.data.ads.length > 0) {
          setPopularAds(res.data.ads);
          setIsPopularAds(false);
        }
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Share_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          iid: id,
          fromDate: daysAgo30(),
          toDate: today(),
          type: 'Day',
        },
      }).then((res) => {
        setShareStats(res.data);
        setIsShareStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Sales}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: daysAgo30(),
          toDate: today(),
          type: 'Day',
          iid: id,
        },
      }).then((res) => {
        setSales(res.data);
        setIsSales(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: daysAgo30(),
          toDate: today(),
          type: 'Day',
          iid: id,
        },
      }).then((res) => {
        setClicks(res.data);
        setIsClicks(false);
      }),
    ]);
  };
  const selectLast90Days = (id) => {
    setButtonText(<IntlMessages id="dashboards.last-90-days" />);
    setLabels(last90Days);
    setfromDate(daysAgo90());
    settoDate(today());
    setIsWebsiteVisit(false);

    setIsSales(true);
    setIsClicks(true);
    setIsStats(true);
    setIsCountryStats(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroups_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo90(),
          dateTo: today(),
          iid: id,
          propertyId: propertyId,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo90(),
          dateTo: today(),
          propertyId: propertyId,
          iid: id,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: daysAgo90(),
          toDate: today(),
          type: 'Day',
          iid: id,
        },
      }).then((res) => {
        setStats(res.data);
        setIsStats(false);
        let v = 0,
          s = 0;
        res.data.voucher.map((m) => {
          v = v + parseInt(m.views);
          s = s + parseInt(m.purchases);
        });
        setStatsData({ views: v, sold: s });
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Ads_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: daysAgo90(),
          toDate: today(),
          type: 'Day',
          iid: id,
        },
      }).then((res) => {
        if (res.data.ads != undefined && res.data.ads.length > 0) {
          setPopularAds(res.data.ads);
          setIsPopularAds(false);
        }
      }),
      
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Share_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          iid: id,
          fromDate: daysAgo90(),
          toDate: today(),
          type: 'Day',
        },
      }).then((res) => {
        setShareStats(res.data);
        setIsShareStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Sales}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: daysAgo90(),
          toDate: today(),
          type: 'Day',
          iid: id,
        },
      }).then((res) => {
        setSales(res.data);
        setIsSales(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: daysAgo90(),
          toDate: today(),
          type: 'Day',
          iid: id,
        },
      }).then((res) => {
        setClicks(res.data);
        setIsClicks(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Country_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo90(),
          dateTo: today(),
          propertyId: propertyId,
          iid: id,
        },
      }).then((res) => {
        setCountryVisit(res.data);
        setIsCountryStats(false);
      }),
    ]);
  };

  const selectThisWeek = (id) => {
    setButtonText(<IntlMessages id="dashboards.this-week" />);
    setLabels(week);

    setfromDate(startOfWeek());
    settoDate(endOfWeek());

    setIsWebsiteVisit(false);

    setIsSales(true);
    setIsClicks(true);
    setIsStats(true);
    setIsCountryStats(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroups_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfWeek(),
          dateTo: endOfWeek(),
          propertyId: propertyId,
          iid: id,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfWeek(),
          dateTo: endOfWeek(),
          propertyId: propertyId,
          iid: id,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Ads_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfWeek(),
          toDate: endOfWeek(),
          type: 'Day',
          iid: id,
        },
      }).then((res) => {
        if (res.data.ads != undefined && res.data.ads.length > 0) {
          setPopularAds(res.data.ads);
          setIsPopularAds(false);
        }
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfWeek(),
          toDate: endOfWeek(),
          type: 'Day',
          iid: id,
        },
      }).then((res) => {
        setStats(res.data);
        setIsStats(false);
        let v = 0,
          s = 0;
        res.data.voucher.map((m) => {
          v = v + parseInt(m.views);
          s = s + parseInt(m.purchases);
        });
        setStatsData({ views: v, sold: s });
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Share_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          iid: id,
          fromDate: startOfWeek(),
          toDate: endOfWeek(),
          type: 'Day',
        },
      }).then((res) => {
        setShareStats(res.data);
        setIsShareStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Sales}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfWeek(),
          toDate: endOfWeek(),
          iid: id,
          type: 'Day',
        },
      }).then((res) => {
        setSales(res.data);
        setIsSales(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Country_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfWeek(),
          dateTo: endOfWeek(),
          iid: id,
          propertyId: propertyId,
        },
      }).then((res) => {
        setCountryVisit(res.data);
        setIsCountryStats(false);
      }),

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfWeek(),
          toDate: endOfWeek(),
          iid: id,
          type: 'Day',
        },
      }).then((res) => {
        setClicks(res.data);
        setIsClicks(false);
      }),
    ]);
  };

  const selectThisMonth = (id) => {
    setButtonText(<IntlMessages id="dashboards.this-month" />);
    setLabels(month);

    setfromDate(startOfMonth());
    settoDate(endOfMonth());

    setIsWebsiteVisit(false);

    setIsSales(true);
    setIsClicks(true);
    setIsStats(true);
    setIsCountryStats(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfMonth(),
          dateTo: endOfMonth(),
          propertyId: propertyId,
          iid: id,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroups_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfMonth(),
          dateTo: endOfMonth(),
          propertyId: propertyId,
          iid: id,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }), AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Ads_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfMonth(),
          toDate: endOfMonth(),
          type: 'Day',
          iid: id,
        },
      }).then((res) => {
        if (res.data.ads != undefined && res.data.ads.length > 0) {
          setPopularAds(res.data.ads);
          setIsPopularAds(false);
        }
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfMonth(),
          toDate: endOfMonth(),
          type: 'Day',
          iid: id,
        },
      }).then((res) => {
        setStats(res.data);
        setIsStats(false);
        let v = 0,
          s = 0;
        res.data.voucher.map((m) => {
          v = v + parseInt(m.views);
          s = s + parseInt(m.purchases);
        });
        setStatsData({ views: v, sold: s });
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Share_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          iid: id,
          fromDate: startOfMonth(),
          toDate: endOfMonth(),
          type: 'Day',
        },
      }).then((res) => {
        setShareStats(res.data);
        setIsShareStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Sales}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfMonth(),
          toDate: endOfMonth(),
          iid: id,
          type: 'Day',
        },
      }).then((res) => {
        setSales(res.data);
        setIsSales(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfMonth(),
          toDate: endOfMonth(),
          type: 'Day',
          iid: id,
        },
      }).then((res) => {
        setClicks(res.data);
        setIsClicks(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Country_Stats}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: startOfMonth(),
          dateTo: endOfMonth(),
          iid: id,
        },
      }).then((res) => {
        setCountryVisit(res.data);
        setIsCountryStats(false);
      }),
    ]);
  };

  const selectPreviousMonth = (id) => {
    setButtonText(<IntlMessages id="dashboards.previous-month" />);
    setLabels(month);

    setfromDate(startOfPreviousMonth());
    settoDate(endOfPreviousMonth());

    setIsWebsiteVisit(false);

    setIsSales(true);
    setIsClicks(true);
    setIsStats(true);
    setIsCountryStats(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfPreviousMonth(),
          dateTo: endOfPreviousMonth(),
          propertyId: propertyId,
          iid: id,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroups_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfPreviousMonth(),
          dateTo: endOfPreviousMonth(),
          propertyId: propertyId,
          iid: id,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Ads_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfPreviousMonth(),
          toDate: endOfPreviousMonth(),
          type: 'Day',
          iid: id,
        },
      }).then((res) => {
        if (res.data.ads != undefined && res.data.ads.length > 0) {
          setPopularAds(res.data.ads);
          setIsPopularAds(false);
        }
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfPreviousMonth(),
          toDate: endOfPreviousMonth(),
          iid: id,
          type: 'Day',
        },
      }).then((res) => {
        setStats(res.data);
        setIsStats(false);
        let v = 0,
          s = 0;
        res.data.voucher.map((m) => {
          v = v + parseInt(m.views);
          s = s + parseInt(m.purchases);
        });
        setStatsData({ views: v, sold: s });
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Share_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          iid: id,
          fromDate: startOfPreviousMonth(),
          toDate: endOfPreviousMonth(),
          type: 'Day',
        },
      }).then((res) => {
        setShareStats(res.data);
        setIsShareStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Sales}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfPreviousMonth(),
          toDate: endOfPreviousMonth(),
          iid: id,
          type: 'Day',
        },
      }).then((res) => {
        setSales(res.data);
        setIsSales(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfPreviousMonth(),
          toDate: endOfPreviousMonth(),
          iid: id,
          type: 'Day',
        },
      }).then((res) => {
        setClicks(res.data);
        setIsClicks(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Country_Stats}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: startOfPreviousMonth(),
          dateTo: endOfPreviousMonth(),
          iid: id,
        },
      }).then((res) => {
        setCountryVisit(res.data);
        setIsCountryStats(false);
      }),
    ]);
  };

  const selectThisYear = (id) => {
    setButtonText(<IntlMessages id="dashboards.yeartodate" />);

    setfromDate(startOfThisYear());
    settoDate(today());

    setIsWebsiteVisit(false);

    setLabels(year);
    setIsSales(true);
    setIsClicks(true);
    setIsStats(true);
    setIsCountryStats(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfThisYear(),
          dateTo: today(),
          propertyId: propertyId,
          iid: id,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsMonth_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfThisYear(),
          dateTo: today(),
          propertyId: propertyId,
          iid: id,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Ads_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfThisYear(),
          toDate: today(),
          type: 'Day',
          iid: id,
        },
      }).then((res) => {
        if (res.data.ads != undefined && res.data.ads.length > 0) {
          setPopularAds(res.data.ads);
          setIsPopularAds(false);
        }
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfThisYear(),
          toDate: today(),
          iid: id,
          type: 'Month',
        },
      }).then((res) => {
        setStats(res.data);
        setIsStats(false);
        let v = 0,
          s = 0;
        res.data.voucher.map((m) => {
          v = v + parseInt(m.views);
          s = s + parseInt(m.purchases);
        });
        setStatsData({ views: v, sold: s });
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Share_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          iid: id,
          fromDate: startOfThisYear(),
          toDate: today(),
          type: 'Month',
        },
      }).then((res) => {
        setShareStats(res.data);
        setIsShareStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Sales}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfThisYear(),
          toDate: today(),
          iid: id,
          type: 'Month',
        },
      }).then((res) => {
        setSales(res.data);
        setIsSales(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          iid: id,
          fromDate: startOfThisYear(),
          toDate: today(),
          type: 'Month',
        },
      }).then((res) => {
        setClicks(res.data);
        setIsClicks(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Country_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfThisYear(),
          dateTo: today(),
          iid: id,
          propertyId: propertyId,
        },
      }).then((res) => {
        setCountryVisit(res.data);
        setIsCountryStats(false);
      }),
    ]);
  };

  const selectLastYear = (id) => {
    setButtonText(<IntlMessages id="dashboards.lastyear" />);
    setLabels(year);
    setIsSales(true);
    setIsClicks(true);
    setIsStats(true);
    setIsCountryStats(true);

    setfromDate(startOfLastYear());
    settoDate(endOfLastYear());

    setIsWebsiteVisit(false);

    setIsSales(true);
    setIsClicks(true);
    setIsStats(true);
    setIsCountryStats(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          iid: id,
          dateFrom: startOfLastYear(),
          dateTo: endOfLastYear(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsMonth_Stats}`,
        params: {
          groupId: getGroupID(),
          iid: id,
          dateFrom: startOfLastYear(),
          dateTo: endOfLastYear(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Ads_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfLastYear(),
          toDate: endOfLastYear(),
          type: 'Day',
          iid: id,
        },
      }).then((res) => {
        if (res.data.ads != undefined && res.data.ads.length > 0) {
          setPopularAds(res.data.ads);
          setIsPopularAds(false);
        }
      }),

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Stats}`,
        params: {
          iid: id,
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfLastYear(),
          toDate: endOfLastYear(),
          type: 'Month',
        },
      }).then((res) => {
        setStats(res.data);
        setIsStats(false);
        let v = 0,
          s = 0;
        res.data.voucher.map((m) => {
          v = v + parseInt(m.views);
          s = s + parseInt(m.purchases);
        });
        setStatsData({ views: v, sold: s });
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Share_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          iid: id,
          fromDate: startOfLastYear(),
          toDate: endOfLastYear(),
          type: 'Month',
        },
      }).then((res) => {
        setShareStats(res.data);
        setIsShareStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Sales}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfLastYear(),
          toDate: endOfLastYear(),
          iid: id,
          type: 'Month',
        },
      }).then((res) => {
        setSales(res.data);
        setIsSales(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfLastYear(),
          toDate: endOfLastYear(),
          iid: id,
          type: 'Month',
        },
      }).then((res) => {
        setClicks(res.data);
        setIsClicks(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Country_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfLastYear(),
          dateTo: endOfLastYear(),
          iid: id,
          propertyId: propertyId,
        },
      }).then((res) => {
        setCountryVisit(res.data);
        setIsCountryStats(false);
      }),
    ]);
  };
  const ReloadStats = (id) => {
    switch (buttonText.props.id) {


      case ("dashboards.last-7-days"):
        selectLast7Days(id);
        break;


      case ("dashboards.last-30-days"):
        selectLast30Days(id);
        break;


      case ("dashboards.last-90-days"):
        selectLast90Days(id);
        break;


      case ("dashboards.this-week"):
        selectThisWeek(id);
        break;


      case ("dashboards.this-month"):
        selectThisMonth(id);
        break;


      case ("dashboards.previous-month"):
        selectPreviousMonth(id);
        break;


      case ("dashboards.yeartodate"):
        selectThisYear(id);
        break;


      case ("dashboards.lastyear"):
        selectLastYear(id);
        break;


      default:
        break;
    }
  };
  return (
    <Fragment>
      <Row>
        <Col xxs="12" className="mb-4">
        <CardHeader style={{ marginLeft: '-1.25rem', marginRight: '-1.25rem' }}>
        <Nav tabs className="card-header-tabs ml-0 mr-0">
          <NavItem className=" text-center" style={{ width: 'auto', background: '' }}>
            <NavLink
              style={{ background: 'none', cursor: 'pointer' }}
              className={({
                active: activeTab === "ToDo",
                "nav-link": true
              })}
              onClick={() => {
                setActiveTab("ToDo");
              }}
              to="#"
            >
              <span style={{ color: `${activeTab === "orders" ? '#EF4A81' : 'black'}` }}>To-do</span>
            </NavLink>
          </NavItem>
          <NavItem className=" text-center" style={{ width: 'auto' }}>
            <NavLink
              style={{ background: 'none', cursor: 'pointer' }}
              className={({
                active: activeTab === "Insights",
                "nav-link": true
              })}
              onClick={() => {
                setActiveTab("Insights");
              }}
              to="#"
            >
              <span style={{ color: `${activeTab === "statement" ? '#EF4A81' : 'black'}` }}>Insights</span>
            </NavLink>
          </NavItem>
        </Nav>
      </CardHeader>
         
            {activeTab === 'Insights' &&
              <Card>
                <CardHeader>
                  <div className="btn-group float-right float-none-xs mt-2">
                    <UncontrolledDropdown>
                      <DropdownToggle
                        caret
                        color="primary"
                        className="btn-xs"
                        outline
                      >
                        {buttonText}
                      </DropdownToggle>
                      <DropdownMenu right>
                        <DropdownItem onClick={() => selectLast7Days(itegrationId)}>
                          <IntlMessages id="dashboards.last-7-days" />
                        </DropdownItem>
                        <DropdownItem onClick={() => selectLast30Days(itegrationId)}>
                          <IntlMessages id="dashboards.last-30-days" />
                        </DropdownItem>
                        <DropdownItem onClick={() => selectLast90Days(itegrationId)}>
                          <IntlMessages id="dashboards.last-90-days" />
                        </DropdownItem>
                        <DropdownItem onClick={() => selectThisWeek(itegrationId)}>
                          <IntlMessages id="dashboards.this-week" />
                        </DropdownItem>
                        <DropdownItem onClick={() => selectThisMonth(itegrationId)}>
                          <IntlMessages id="dashboards.this-month" />
                        </DropdownItem>
                        <DropdownItem onClick={() => selectPreviousMonth(itegrationId)}>
                          <IntlMessages id="dashboards.previous-month" />
                        </DropdownItem>
                        <DropdownItem onClick={() => selectThisYear(itegrationId)}>
                          <IntlMessages id="dashboards.yeartodate" />
                        </DropdownItem>
                        <DropdownItem onClick={() => selectLastYear(itegrationId)}>
                          <IntlMessages id="dashboards.lastyear" />
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </div>
                  <div className="btn-group ml-1 float-right float-none-xs mr-1 mt-2">
                    {integration.length > 1 && <UncontrolledDropdown>
                      <DropdownToggle
                        caret
                        color="primary"
                        className="btn-xs"
                        outline
                      >
                        {integrationName === "All" ? "All Integrations" : integrationName}
                      </DropdownToggle>
                      <DropdownMenu right>
                        <DropdownItem onClick={() => { setIntregationId('All'); setIntregationName('All'); ReloadStats('All'); }}>
                          All Integrations
                        </DropdownItem>
                        {integration.length > 0 && integration.map((i) => (
                          <DropdownItem onClick={() => { setIntregationId(i.id); setIntregationName(i.name); ReloadStats(i.id); }}>
                            {i.name}
                          </DropdownItem>
                        ))}
                      </DropdownMenu>
                    </UncontrolledDropdown>}
                  </div>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col sm="12" md="6" className="mb-4">
                      {isWebsiteVisit ? (
                        <div className="text-center">
                          <Spinner style={{ color: '#EF4A81' }} className="mb-1" />
                        </div>
                      ) : (
                        <WebsiteVisitsChartCard
                          labels={labels}
                          visitorStatsData={visitorStatsData}
                        />
                        // <p style={{ textAlign: 'center' }}>Temporarily Unavailable</p>
                      )}
                    </Col>

                    {isVoucherEngine || domains.length == 1 ? (
                      <Col sm="12" md="6" className="mb-4">
                        {isclicks ? (
                          <div className="text-center">
                            <Spinner style={{ color: '#EF4A81' }} className="mb-1" />
                          </div>
                        ) : (
                          <VoucherClicks labels={labels} data={clicks.dataset} />
                          // <p style={{ textAlign: 'center' }}>Temporarily Unavailable</p>
                        )}
                      </Col>
                    ) : (
                      ''
                    )}
                    {isVoucherEngine || domains.length == 1 ? (
                      <Col sm="12" md="6" className="mb-4">
                        {isSales ? (
                          <div className="text-center">
                            <Spinner style={{ color: '#EF4A81' }} className="mb-1" />
                          </div>
                        ) : (
                          <VoucherEngineSales labels={labels} data={sales.dataset} />
                          // <p style={{ textAlign: 'center' }}>Temporarily Unavailable</p>
                        )}
                      </Col>
                    ) : (
                      ''
                    )}
                    {isVoucherEngine || domains.length == 1 ? (
                      <Col sm="12" md="6" className="mb-4">
                        {isCountryStats ? (
                          <div className="text-center">
                            <Spinner style={{ color: '#EF4A81' }} className="mb-1" />
                          </div>
                        ) : (
                          countryvisit.length > 0 && (
                            <VoucherEngineVisits
                              labels={voucherEngineVisits}
                              data={countryvisit}
                            />
                          )
                        )}
                      </Col>
                    ) : (
                      ''
                    )}
                    {isVoucherEngine || domains.length == 1 ? (
                      <Col sm="12" md="6" className="mb-4">
                        {isStats ? (
                          <div className="text-center">
                            <Spinner style={{ color: '#EF4A81' }} className="mb-1" />
                          </div>
                        ) : (
                          <PopularVoucher
                            labels={poupularVoucherDataTablescolumn}
                            data={stats.voucher}
                            revenue={sales.revenue}
                            locale={locale}
                            statsData={statsData}
                            currency={currency}
                            clicks={clicks.clicks}
                          />
                          // <p style={{ textAlign: 'center' }}>Temporarily Unavailable</p>
                        )}
                      </Col>
                    ) : (
                      ''
                    )}
                    {(isVoucherEngine || domains.length == 1) && !isPopularAds ? (
                      <Col sm="12" md="6" className="mb-4">
                        {isPopularAds ? (
                          <div className="text-center">
                            <Spinner style={{ color: '#EF4A81' }} className="mb-1" />
                          </div>
                        ) : (
                          <PopularAds
                            labels={popularAdsDataTablecolumn}
                            data={popularAds}
                            locale={locale}
                          />
                          // <p style={{ textAlign: 'center' }}>Temporarily Unavailable</p>
                        )}
                      </Col>
                    ) : (
                      ''
                    )}

                    {isVoucherEngine || domains.length == 1 ? (
                      <Col sm="12" md="6" className="mb-4">
                        {
                          isStats ? (
                            <div className="text-center">
                              <Spinner style={{ color: '#EF4A81' }} className="mb-1" />
                            </div>
                          ) : (
                            stats.recentOrders !== undefined && stats.recentOrders.length > 0 && (
                              <RecentOrder data={stats.recentOrders} />
                            )
                          )
                          // <p style={{ textAlign: 'center' }}>Temporarily Unavailable</p>
                        }
                      </Col>
                    ) : (
                      ''
                    )}
                    {isVoucherEngine || domains.length == 1 ? (
                      <Col sm="12" md="6" className="mb-4">
                        {isShareStats ? (
                          <div className="text-center">
                            <Spinner style={{ color: '#EF4A81' }} className="mb-1" />
                          </div>
                        ) : (
                          <VoucherEngineShare labels={labels} data={shareStats.dataset} />
                          // <p style={{ textAlign: 'center' }}>Temporarily Unavailable</p>
                        )}
                      </Col>
                    ) : (
                      ''
                    )}
                    <Col sm="12" md="12" className="mb-4">
                      {isContact ? (
                        <div className="text-center">
                          <Spinner style={{ color: '#EF4A81' }} className="mb-1" />
                        </div>
                      ) : (
                        <Contact
                          labels={dataTableColumnsContacts}
                          data={contactStatsData}
                          timeZone={timeZone}
                          propertyId={propertyId}
                          isMasked={isMasked}
                        />
                      )}
                    </Col>
                    <UserGuide></UserGuide>
                  </Row>
                </CardBody>
              </Card>}
            {activeTab === 'ToDo' &&
             
                <Row>
                  {isVoucherEngine || domains.length == 1 ? (
                    <Col sm="12" md="6" className="mb-4">
                      {isStats ? (
                        <div className="text-center">
                          <Spinner style={{ color: '#EF4A81' }} className="mb-1" />
                        </div>
                      ) : (                        
                        <ToDo
                          labels={poupularVoucherDataTablescolumn}
                          data={stats.voucher}
                          revenue={sales.revenue}
                          locale={locale}
                          statsData={statsData}
                          currency={currency}
                          clicks={clicks.clicks}
                          propertyId={propertyId}
                        />                        
                        // <p style={{ textAlign: 'center' }}>Temporarily Unavailable</p>
                      )}
                    </Col>
                  ) : (
                    ''
                  )}
                </Row>
              }                   
        </Col>
      </Row>
    </Fragment>
  );
}
const mapStateToProps = ({ authUser, settings, oidc }) => {
  const { user: loginUser } = authUser;
  const {
    locale,
    propertyId,
    isVoucherEngine,
    timeZone,
    email,
    domains,
    currency,
  } = settings;
  return {
    loginUser,
    locale,
    oidc,
    isVoucherEngine,
    propertyId,
    timeZone,
    email,
    domains,
    currency,
  };
};
